import Vue from 'vue';
import $ from "jquery";

// plugins

import './plugins/xWindow';

// modules

// progressTracker

import './modules/checkboxes';
import './modules/countrySelect';
import './modules/hcpOverlay';
import './modules/overlay';
import './modules/institution';
import './modules/resourceTrigger';
import './modules/reveal';
import './modules/scroll';
import './modules/pancakeNav';
import './modules/selectSubmit';
import './vendor/collapse';
import './modules/slideProgress';
import './modules/downloadProgress';

import CookieBanner from './components/CookieBanner.vue';
import CookiePanel from './components/CookiePanel.vue';



Vue.component('cookie-banner', CookieBanner);
Vue.component('cookie-panel', CookiePanel);



const app = new Vue({
    el: '#app',

    mounted() {
        $.holdReady(false)
        const error = document.querySelector('[data-js-error]');
        if(error){
            error.scrollIntoView();
        }
    }
});
